var React = require('react');

function RoundTick (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0DB0E7;}")),React.createElement("path",{"id":"path-1","className":"cls-1","d":"M9,18a9,9,0,1,1,9-9A9,9,0,0,1,9,18Zm0-.9A8.1,8.1,0,1,0,.9,9h0A8.07,8.07,0,0,0,9,17.05ZM5.4,8.75l-.9.9,2.8,2.8,6.2-6.2-.9-.9-5.4,5.4Z","key":1})]);
}

RoundTick.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18","fill":"#0DB0E7"};

module.exports = RoundTick;

RoundTick.default = RoundTick;
